// extracted by mini-css-extract-plugin
export default {"warnings":"oQ4jVHjt7FGj_MLApxET","warning":"n2PvXZio5VJve29lFQHw"};